import {
    Grid
} from "@mui/material";

import MDBox from "../../../components/MDBox";
import AssetVisualization from "../../../components/AssetVisualization";

function RelationshipsTab(){
    return (
        <MDBox bgColor="gray-100" sx={{width: "100%", display: "flex", minHeight: "80vh"}}>
            <Grid container justifyContent="center">
                <Grid item xs={12}>
                    <AssetVisualization />
                </Grid>
            </Grid>
        </MDBox>
    );
}

export default RelationshipsTab;